import React from 'react';
import { Button, TextInput } from '@mantine/core';
import type { AreaTableShape } from '../../../../../services/areas/areas.service';
import classes from './AddTablePalette.module.scss';

type AddTablePaletteProps = {
  number: string;
  shape: AreaTableShape | null;
  onNumberChange: (number: string) => void;
  onShapeChange: (shape: AreaTableShape) => void;
};

// Manager types a number, picks a shape (stays selected), then clicks the canvas to place it.
const AddTablePaletteComponent: React.FC<AddTablePaletteProps> = ({ number, shape, onNumberChange, onShapeChange }) => (
  <div className={classes.palette} dir="rtl">
    <TextInput
      unstyled
      data-testid="add-table-palette-number"
      classNames={{ input: classes.numberField }}
      value={number}
      onChange={(event) => onNumberChange(event.currentTarget.value)}
      placeholder="מספר שולחן חדש"
      maxLength={30}
      aria-label="מספר שולחן חדש"
    />
    <Button
      unstyled
      type="button"
      data-testid="add-table-palette-square"
      classNames={{ root: `${classes.shape} ${shape === 'square' ? classes.shapeActive : ''}`, inner: classes.shapeInner, label: classes.shapeLabel }}
      onClick={() => onShapeChange('square')}
      aria-label="שולחן מרובע"
      aria-pressed={shape === 'square'}
    >
      <span className={`${classes.glyph} ${classes.glyphSquare}`} />
      <span className={classes.shapeText}>מרובע</span>
    </Button>
    <Button
      unstyled
      type="button"
      data-testid="add-table-palette-circle"
      classNames={{ root: `${classes.shape} ${shape === 'circle' ? classes.shapeActive : ''}`, inner: classes.shapeInner, label: classes.shapeLabel }}
      onClick={() => onShapeChange('circle')}
      aria-label="שולחן עגול"
      aria-pressed={shape === 'circle'}
    >
      <span className={`${classes.glyph} ${classes.glyphCircle}`} />
      <span className={classes.shapeText}>עגול</span>
    </Button>
  </div>
);

export const AddTablePalette = React.memo(AddTablePaletteComponent);
